module.exports = __webpack_public_path__ + "static/media/capture.9ad3c19f.PNG";